// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1d22f5{position:relative;padding-bottom:56.25%}._1d22f5 iframe,._1d22f5 video{position:absolute;top:0;left:0;width:100%;height:100%;border-radius:var(--radius)}._1b096a{padding:0;width:80vw;max-width:40em}._35f78e{position:absolute;color:#fff;top:-1.5em;right:-1.5em;bottom:auto;left:auto;font-size:1.5em}", ""]);
// Exports
exports.locals = {
	"container": "_1d22f5",
	"modal": "_1b096a",
	"close": "_35f78e"
};
module.exports = exports;
